<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner inline-actions class="bg-blue text-white">
        <span v-if="items && items.length>0">اهداف کالایی {{ items[0].UserName }}</span>
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="text-center">
      <div v-if="items && items.length>0" class="text-subtitle2">{{ items[0].Goods_Name }}</div>
      <q-chip color="indigo" text-color="white" :label="items[0].Group_Name"  v-if="items && items.length>0"/>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-table
          :data="items"
          row-key="Goods_ID"
          wrap-cells
          flat
          :hide-header="$q.screen.lt.md"
          :hide-bottom="!$q.screen.lt.md"
          :rows-per-page-options="[0]">
        <template v-slot:header>
          <q-tr class="text-bold">
            <td class="text-center">شماره فاکتور</td>
            <td class="text-center">نام مشتری</td>
            <td class="text-center">تعداد فروخته شده</td>
            <td class="text-center">تعداد برگشت داده شده</td>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class text-center" v-if="!$q.screen.lt.md">
            <td>
              <q-chip square color="indigo" text-color="white" :label="props.row.Sale_Num"/>
            </td>
            <td class="text-left">
              <q-chip icon="person" square :label="props.row.CS_Name"/>
            </td>
            <td>
              <q-chip square color="green" text-color="white" :label="props.row.SaleG_Count"/>
            </td>
            <td>
              <q-chip square color="red-10" text-color="white" :label="props.row.ReturnSaleG_Count"/>
            </td>
          </q-tr>
          <q-tr :props="props" v-if="$q.screen.lt.md">
            <td>
              <q-card class="shadow-5">
                <q-card-section class="text-center no-padding">
                  <q-chip square color="indigo" text-color="white" :label="props.row.Sale_Num"/>
                  <q-chip icon="person" square :label="props.row.CS_Name"/>
                </q-card-section>
                <q-card-section class="no-padding text-center">
                  <q-chip square color="green" text-color="white" label="تعداد فروش">
                    <q-badge class="q-ml-xs" color="red-10" text-color="white" :label="props.row.SaleG_Count"/>
                  </q-chip>
                  <q-chip square color="red-10" text-color="white" label="تعداد برگشت از فروش">
                    <q-badge class="q-ml-xs" color="indigo-10" text-color="white" :label="props.row.ReturnSaleG_Count"/>
                  </q-chip>
                </q-card-section>
              </q-card>
            </td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "TargetGoodsDetails",
  props: {
    startDate: {
      type: String,
      required: true
    },
    endDate: {
      type: String,
      required: true
    },
    userId: {
      type: Number,
      required: true
    },
    agentName: {
      type: String,
      required: true
    },
    goodsCode:{
      type:Number,
      required:true
    }
  },
  data(){
    return{
      items:[]
    }
  },
  methods:{
    ...mapActions({
      getData: 'Agents/getGoodsCommissionDetails',
    })
  },
  created() {
    this.getData({
      startDate: this.startDate.replaceAll('/', '-'),
      endDate: this.endDate.replaceAll('/', '-'),
      userId: this.userId,
      goodsCode: this.goodsCode
    }).then((res) => {
      this.items = res
    })
  }
}
</script>

<style scoped>

</style>